import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { Button, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { Control, Controller, useFieldArray } from 'react-hook-form';

import FormTextInput from 'portal/src/components/common/forms/FormTextInput';

import { OrganizationFormFields } from './OrganizationForm.fields';

const PasswordRuleOverridesForm = ({
  control,
}: {
  control: Control<OrganizationFormFields>;
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'passwordRuleOverrides',
  });

  return (
    <>
      <Typography variant="body2" gutterBottom>
        Overrides the default password rules for this organization's users. Each
        rule requires a description shown to users and a regular expression the
        password must satisfy.
      </Typography>
      {fields.map((field, index) => (
        <Grid container spacing={1} key={field.id} sx={{ mb: 1 }}>
          <Grid size={5}>
            <Controller
              name={`passwordRuleOverrides.${index}.constraint`}
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <FormTextInput
                  {...field}
                  placeholder="Rule Description"
                  label="Rule Description"
                  required
                  error={fieldState.invalid}
                />
              )}
            />
          </Grid>
          <Grid size={6}>
            <Controller
              name={`passwordRuleOverrides.${index}.regex`}
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <FormTextInput
                  {...field}
                  placeholder="Regular Expression"
                  label="Regular Expression"
                  required
                  error={fieldState.invalid}
                />
              )}
            />
          </Grid>
          <Grid size={1} display="flex" alignItems="center">
            <Tooltip title="Remove Rule">
              <IconButton
                aria-label="Remove Rule"
                onClick={() => remove(index)}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      ))}
      <Grid container justifyContent="flex-end">
        <Button
          color="primary"
          onClick={() => append({ constraint: '', regex: '' })}
          startIcon={<AddIcon />}
          variant="contained"
          size="small"
        >
          Add Rule
        </Button>
      </Grid>
    </>
  );
};

export default PasswordRuleOverridesForm;
